import {
  BookingRequest,
  BookingResponse,
  Product,
  Shop,
  VehicleInfo,
  OrderInfo,
  CallData,
  ProductsResponse
} from '../mrCapTypes';
import { post, get } from './webapi';
import { intoQueryString, getCampaignId } from '../util';

const api = '/mrcap/booking';

export async function getProducts(stationId: number, regNr?: string) {
  return get<ProductsResponse>(intoQueryString(`${api}/products`, {
    stationId,
    regNr,
    campaignId: getCampaignId()
  }));
}

export async function getCarDetails(regNr: string) {
  return get<VehicleInfo>(`${api}/info/${regNr}`);
}

export async function getProductRules(articles: string[]) {
  return get<string[]>(intoQueryString(`${api}/product/rules`, {
    articles: articles.join(';'),
    campaignId: getCampaignId()
  }));
}

export async function create() {
  return get<BookingResponse>(`${api}/create`);
}

export async function update(bookingId: string, booking: BookingRequest) {
  return post<BookingResponse>(`${api}/update/${bookingId}`, booking);
}

export async function postBooking(bookingId: string, booking: BookingRequest) {
  return post<BookingResponse>(`${api}/post/${bookingId}`, booking);
}

export async function orderInfo(bookingId: string) {
  return get<OrderInfo>(`${api}/order/${bookingId}`);
}

export async function ecsterCreateCart(bookingId: string) {
  return get<string>(`${api}/ecster/create/${bookingId}`);
}

export async function getShops() {
  return get<Shop[]>(`${api}/shops`);
}

export async function getShopTimes(shopId: number) {
  const dates = await get<string[]>(`${api}/shops/${shopId}/times`);
  return dates.map(date => new Date(date));
}

export async function postCallData(callData: CallData) {
  return post<any>(`${api}/post/call-data`, callData);
}